<template>
  <WsUpdate
    ref="wsUpdate"
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/app";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄目前編輯內容嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "",
              fields: ["name"],
            },
          ],
        },
      ],
    },
  }),
};
</script>